import { useDataValue } from 'Simple/Data'
import { uuid } from 'Data/validate'

/*
 * We have a situation where the connection.id can be an uuid when the data come from `apps_connections` or
 * it can be the connection name when it comes from the json metadata
 * This helper gets the connection name that I need for the action
 * */
function getConnectionName(connection) {
  return uuid(connection.id) ? connection.name : connection.id
}

/** @type {import('Simple/types.js').useDataConfiguration} */
export default function useDataConfiguration(props, data) {
  let connection = useDataValue({
    viewPath: props.viewPath,
    context: 'connection',
  })
  let location_id = useDataValue({
    viewPath: props.viewPath,
    context: 'global',
    path: 'current_location._id',
  })
  return {
    variables: {
      connection_name: getConnectionName(connection),
      location_id,
      app_id: connection.app_id,
    },
    pause: !location_id || !connection,
  }
}
